
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {incomingChallengesModule, incomingChallengesState} from '@/utils/store-acessor';
  import {ChallengeModel} from '@/models/challenge.model';
  import ChallengesSituationsTemplate from '@/components/Challenges/ChallengesSituationsTemplate.vue';

  @Component({
    components: {
      ChallengesSituationsTemplate
    }
  })
  export default class ChallengeComingSoon extends Vue {
    @incomingChallengesModule.Getter('challenges') challenges!: ChallengeModel[];
    @incomingChallengesModule.Getter('lastPage') lastPage!: number;
    @incomingChallengesModule.Getter('currentPage') page!: number;
    @incomingChallengesModule.Getter('loading') loading!: number;
    @incomingChallengesModule.Getter('challengesByTag') challengesByTag!: (tag: string) => ChallengeModel[];

    get tag(): string | null {
      return this.$route.query?.tag?.toString() || null
    }

    get emptyMessage(): string {
      return !!this.tag ? this.$t('challenge.labels.no_challenges_comming_soon_with_tag', [this.tag]).toString() : this.$t('challenge.labels.no_challenges_comming_soon').toString()
    }

    get challengesFiltered(): ChallengeModel[] {
      if (this.tag) {
        return this.challengesByTag(this.tag)
      }
      return this.challenges
    }


    async mounted() {
      this.makeRequest(1)
    }

    async inBottom() {
      if (this.page < this.lastPage && !this.loading) {
        this.makeRequest(this.page + 1)
      }
    }

    private async makeRequest(page: number = 1) {
      const tag = this.$route.query?.tag?.toString();
      await incomingChallengesState.fetchAll({
        page,
        tag
      });
    }
  }
